<template>
  <div class="w-[10rem] grid grid-cols-1 grid-rows-[auto_auto_auto] justify-center items-center">
    <div class="w-full h-full flex flex-col justify-end items-center pb-4">
      <template v-if="tiers?.one == 0 && tiers?.two == 0 && tiers?.three == 0">
        <div class="w-full h-[5rem]"></div>
      </template>

      <template v-if="tiers?.one == 0 && tiers?.two == 0 && tiers?.three == 1">
        <img src="https://oxbull-presale.s3.amazonaws.com/tier3.svg" alt="" class="w-[5rem] h-[5rem]" />
      </template>

      <template v-if="tiers?.one == 0 && tiers?.two == 1 && tiers?.three == 0">
        <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[5rem] h-[5rem]" />
      </template>

      <template v-if="tiers?.one == 0 && tiers?.two == 2 && tiers?.three == 0">
        <div class="flex justify-center items-center h-[5rem]">
          <div class="flex justify-center items-center relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[4rem] h-[4rem] z-10" />
            <!-- <div class="h-4 w-4 absolute bottom-2 left-2 bg-turquoise-500 text-turquoise-1000 ring ring-turquoise-300 rounded-full flex justify-center items-center text-xs z-40 ">1</div> -->
          </div>
          <div class="flex justify-center items-center flex-col -ml-[20%]">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[4rem] h-[4rem] scale-90 rotate-12 z-0" />
          </div>
        </div>
      </template>

      <template v-if="tiers?.one == 1 && tiers?.two == 0 && tiers?.three == 0">
        <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[5rem] h-[5rem]" />
      </template>

      <template v-if="tiers?.one > 1 && tiers?.two == 0 && tiers?.three == 0">
        <div class="flex justify-center items-center relative">
          <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[5rem] h-[5rem]" />
          <div v-if="tiers?.one > 1" class="h-6 w-6 absolute bottom-1 right-1 bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">{{ tiers?.one }}</div>
        </div>
      </template>

      <template v-if="tiers?.one >= 1 && tiers?.two == 1 && tiers?.three == 0">
        <div class="flex justify-center items-center">
          <div class="flex justify-center items-center relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[5rem] h-[5rem] z-10" />
            <!-- <div v-if="tiers?.one > 1" class="h-4 w-4 absolute bottom-1 left-0 bg-turquoise-500 text-turquoise-1000 ring ring-turquoise-300 rounded-full flex justify-center items-center text-xs z-40 "> {{ tiers?.one }}</div> -->

            <div v-if="tiers?.one > 1" class="h-5 w-5 absolute bottom-1 right-0 text-xs bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">{{ tiers?.one }}</div>
          </div>
          <div class="flex justify-center items-center flex-col -ml-[20%] relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[4rem] h-[4rem] scale-90 rotate-12 z-0" />
          </div>
        </div>
      </template>

      <template v-if="tiers?.one >= 1 && tiers?.two == 2 && tiers?.three == 0">
        <div class="flex justify-center items-center">
          <div class="flex justify-center items-center flex-col -mr-[20%] relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[4rem] h-[4rem] scale-90 -rotate-12 z-0" />
          </div>

          <div class="flex justify-center items-center relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[5rem] h-[5rem] z-10" />
            <!-- <div v-if="tiers?.one > 1" class="h-4 w-4 absolute bottom-1 left-0 bg-turquoise-500 text-turquoise-1000 ring ring-turquoise-300 rounded-full flex justify-center items-center text-xs z-40 "> {{ tiers?.one }}</div> -->

            <div v-if="tiers?.one > 1" class="h-5 w-5 absolute bottom-1 right-0 text-xs bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">{{ tiers?.one }}</div>
          </div>

          <div class="flex justify-center items-center flex-col -ml-[20%] relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[4rem] h-[4rem] scale-90 rotate-12 z-0" />
          </div>
        </div>
      </template>

      <div class="flex justify-center flex-col items-center pt-2">
        <p class="text-sm">{{ title }}</p>
      <p class="text-center font-semibold -mt-2 text-white">{{ amount }} OXI</p>


        <!-- <VDropdown :positioning-disabled="true">
          <button :class="amount > 0 ? '' : 'w-0 h-0 overflow-hidden'" class="ml-1 btn btn-circle btn-xs text-base p-0 m-0 btn-ghost text-woodsmoke-100 tier_detail_info_button">
            <span class="iconify" data-icon="material-symbols:info"></span>
          </button>

          <template #popper="{ hide }">
            <div class="w-full h-full bg-tr">
              <div class="text-woodsmoke-50 p-4 ">
                <div class="mb-4 text-lg font-light space-y-4">
                  <p class="">Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit, perferendis beatae hic magni architecto eum illo consequuntur commodi ipsum fuga tempora, deleniti quis similique debitis id saepe quaerat nesciunt impedit!</p>
                </div>

                <button @click="hide()" class="btn w-full bg-woodsmoke-800 text-turquoise-500 text-lg tracking-widest border border-woodsmoke-700">Close</button>
              </div>
            </div>
          </template>
        </VDropdown> -->

        <!-- <button @click="showTierDetails = true" :class="amount > 0 && !(staked >= amount) ? '' : 'w-0 h-0 overflow-hidden'" class="ml-1 btn btn-circle btn-xs text-base p-0 m-0 btn-ghost text-woodsmoke-100 tier_detail_info_button">
          <span class="iconify" data-icon="material-symbols:info"></span>
        </button> -->

        <TransitionRoot as="template" :show="showTierDetails">
          <Dialog as="div" class="relative z-10" @close="showTierDetails = false">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
              <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
              <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                  <DialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-850 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                    <div class="w-full">
                      <div class="w-full flex justify-between items-center mb-8">
                        <div>
                          <p class="text-sm">required amount</p>
                          <p class="text-2xl text-white">{{ amount }} OXI</p>
                        </div>

                        <div>
                          <p>you need {{ amount - staked }} OXI</p>
                        </div>
                      </div>

                      <div class="space-y-2">
                        <p class="text-sm mb-4">
                          When you've staked <span class="text-white">{{ amount }} OXI</span> tokens, you will get:
                        </p>

                        <div v-if="tiers.one > 0" class="p-2 bg-white/5 w-full rounded-md">
                          <div class="flex justify-start space-x-2 items-center">
                            <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[2rem] h-[2rem] col-span-1" />
                            <div class="">{{ tiers.one }} X Tier One</div>
                          </div>

                          <div class="text-sm pl-4 pt-2">
                            <ul class="list-disc">
                              <li>Allocation: Guaranteed</li>
                              <li>High Allocation</li>
                              <li>Private Sale Access: Yes</li>
                            </ul>
                          </div>
                        </div>

                        <div v-if="tiers.two > 0" class="p-2 bg-white/5 w-full rounded-md">
                          <div class="flex justify-start space-x-2 items-center">
                            <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[2rem] h-[2rem] col-span-1" />
                            <div class="">{{ tiers.two }} X Tier Two</div>
                          </div>

                          <div class="text-sm pl-4 pt-2">
                            <ul class="list-disc">
                              <li>Allocation: Guaranteed</li>
                              <li>Medium Allocation</li>
                              <!-- <li>Private Sale Access: Yes if Private Sale Pass activated</li> -->
                            </ul>
                          </div>
                        </div>

                        <div v-if="tiers.three > 0" class="p-2 bg-white/5 w-full rounded-md">
                          <div class="flex justify-start space-x-2 items-center">
                            <img src="https://oxbull-presale.s3.amazonaws.com/tier3.svg" alt="" class="w-[2rem] h-[2rem] col-span-1" />
                            <div class="">{{ tiers.three }} X Tier Three</div>
                          </div>

                          <div class="text-sm pl-4 pt-2">
                            <ul class="list-disc">
                              <li>Allocation: First Come First Serve</li>
                              <li>Low Allocation</li>
                              <!-- <li>Private Sale Access: Yes if Private Sale Pass activated</li> -->
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-5 sm:mt-6">
                      <button type="button" class="inline-flex w-full justify-center rounded-md bg-woodsmoke-700 px-3 py-2 text-sm font-semibold text-turquoise-500 shadow-sm hover:bg-woodsmoke-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" @click="showTierDetails = false">Go back</button>
                    </div>
                  </DialogPanel>
                </TransitionChild>
              </div>
            </div>
          </Dialog>
        </TransitionRoot>
      </div>
    </div>

    <div class="w-full flex-shrink-0 flex items-center relative -mt-6" :class="[amount > 0 ? 'justify-center' : 'justify-end']">
      <div class="h-2 bg-white/10" :class="[amount > 0 ? 'w-full' : ' w-1/2']"></div>
      <div v-if="amount != 0" class="bg-turquoise-500 h-4 left-[-50%] absolute" :style="`width:${progressWidth}%;`"></div>
      <div v-if="amount != 0" class="bg-white h-4 absolute left-[-50%]" :style="`width:${stakeInputWidth}%;`"></div>
      <!-- <div class="h-4 w-4 bg-white/50 rounded-full absolute"></div> -->
    </div>

    <div class="flex justify-center items-center flex-col">
      <!-- <p class="text-center font-semibold">{{ amount }} OXB</p> -->
      <button @click="selectTier()" v-if="amount > 0 && !(staked >= amount)" class="btn btn-link btn-xs p-0 m-0 text-turquoise-300 tier_select_button min-h-0 h-auto">Select</button>
    </div>
  </div>
</template>

<script setup>
// import { toRefs, computed, ref } from "vue";

const props = defineProps(["state", "tiers", "title", "amount", "stakeInput", "prev", "staked"]);
const { state, tiers, amount, stakeInput, prev, staked } = toRefs(props);

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
const showTierDetails = ref(false);

const title = computed(() => {
  if (tiers.value.one == 0 && tiers.value.two == 0 && tiers.value.three == 0) return "No Tier";
  if (tiers.value.three == 1) return "Tier 3";
  if (tiers.value.two == 1 && tiers.value.three == 0 && tiers.value.one == 0) return "Tier 2";
  if (tiers.value.one == 1 && tiers.value.two == 0 && tiers.value.three == 0) return "Tier 1";
  if (tiers.value.one == 0 && tiers.value.two > 1 && tiers.value.three == 0) return `${tiers.value.two} x Tier 2`;

  if (tiers.value.one == 1 && tiers.value.two == 1 && tiers.value.three == 0) return "Tier 1 + Tier 2";
  if (tiers.value.one == 1 && tiers.value.two == 2 && tiers.value.three == 0) return "Tier 1 + 2 x Tier 2";

  if (tiers.value.one > 1 && tiers.value.two == 0 && tiers.value.three == 0) return `${tiers.value.one} x Tier 1`;
  if (tiers.value.one > 1 && tiers.value.two == 1 && tiers.value.three == 0) return `${tiers.value.one} x Tier 1 + Tier 2`;
  if (tiers.value.one > 1 && tiers.value.two > 1 && tiers.value.three == 0) return `${tiers.value.one} x Tier 1 + ${tiers.value.two} x Tier 2`;
});

const stakeInputWidth = computed(() => {
  let amountToBe = staked.value;

  if (amountToBe == amount.value) return 100;
  if (amountToBe > amount.value) return 100;

  const bar = amount.value - prev.value;
  const now = amountToBe - prev.value;

  //   console.log(now, "===", bar);
  const progress = (now / bar) * 100;
  return progress;
});

const progressWidth = computed(() => {
  let amountToBe = staked.value + stakeInput.value;

  if (amountToBe == amount.value) return 100;
  if (amountToBe > amount.value) return 100;

  const bar = amount.value - prev.value;
  const now = amountToBe - prev.value;

  //   console.log(now, "===", bar);
  const progress = (now / bar) * 100;
  return progress;
  // console.log(( (amount.value - stakeInput.value) / bar.value ) * 100, "===", amount.value, "===", stakeInput.value, "===", bar.value)
  // return ( (amount.value - stakeInput.value) / bar.value ) * 100;
});

const emit = defineEmits(["selectTier"]);

const selectTier = () => {
  emit("selectTier", amount.value);
};
</script>
